import React from 'react';

import InboxNotificationItem from '@/containers/Inbox/InboxView/components/InboxNotificationItem/InboxNotificationItem';

export const NotificationItem = (props) => {
    return <InboxNotificationItem {...props} />;
};
